exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.promoOffer {\r\n    border: solid 1px #fda5a5;\r\n    background-color: #fdfdbc;\r\n    padding: 20px;\r\n    margin-bottom: 40px;\n}\n.moreInfo, .moreInfo:hover {\r\n    color: gray;\n}\n.promoButton2025 {\r\n    margin-top: 20px;\n}\r\n", ""]);

// exports
